<h2 mat-dialog-title>
    <mat-icon>beach_access</mat-icon>
    Solicitar vacaciones / días personales
</h2>

<mat-dialog-content>

    <p class="dialog-description">
        Seleccione el periodo que desea solicitar.
    </p>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tipo de solicitud</mat-label>

        <mat-select [(ngModel)]="requestType">
            <mat-option value="holidays">
                Vacaciones
            </mat-option>

            <mat-option value="personal_day">
                Días personales
            </mat-option>
        </mat-select>

    </mat-form-field>


    <mat-form-field appearance="outline" class="full-width">

        <mat-label>Periodo de vacaciones / días personales</mat-label>

        <mat-date-range-input
            [rangePicker]="picker">

            <input
                matStartDate
                [(ngModel)]="startDate"
                placeholder="Fecha inicio"
                readonly>

            <input
                matEndDate
                [(ngModel)]="endDate"
                placeholder="Fecha fin"
                readonly>

        </mat-date-range-input>

        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

    </mat-form-field>

    @if (startDate && endDate) {
        <div class="selected-period">
            <mat-icon>event</mat-icon>

            <div>
                <strong>{{ startDate | date:'dd/MM/yyyy' }}</strong>
                →
                <strong>{{ endDate | date:'dd/MM/yyyy' }}</strong>
                ({{ getVacationDays() }} {{ getVacationDays() === 1 ? 'día' : 'días' }})
            </div>
        </div>
    }

</mat-dialog-content>


<mat-dialog-actions align="end">

    <button mat-stroked-button (click)="onCancel()">
        Cancelar
    </button>

    <button
        mat-flat-button
        color="primary"
        (click)="onAccept()"
        [disabled]="!startDate || !endDate || isDeleting">
        <mat-icon>send</mat-icon>
        Solicitar
    </button>

</mat-dialog-actions>